<template>
  <div class="login-wrapper" dark>
    <v-row style="align-items: center;">
      <v-col cols="12" lg="5" md="5">
        <v-main class="login-content">
          <v-img src="../assets/logo-ui.png" max-width="328" class="mb-5"/>
          <div class="login-transition-wrapper">
            <transition :name="transitionName" mode="out-in">
              <div :key="loginMode" class="login-slide" :class="{ 'center-content': loginMode === 'choose' }">
                <div v-if="loginMode === 'choose'">
                  <div class="mb-4">
                    <h3 style="font-weight: 800 !important;" class="text-white text-xl font-bold">{{ $vuetify.lang.t('$vuetify.login') }} eSign</h3>
                    <p class="text-white">Silakan pilih metode masuk untuk melanjutkan.</p>
                  </div>

                  <p class="text-white">Civitas UI</p>
                  <v-btn
                      style="border-color: #FFDD00;"
                      class="mt-1 mb-4"
                      block
                      outlined
                      :loading="loadingSso"
                      @click="loginSSO()"
                  ><span class="text-primary">Login SSO</span>
                  </v-btn>

                  <div class="divider my-4">
                    <span class="divider-text text-white">Atau</span>
                  </div>

                  <p class="text-white">Akun Internal</p>
                  <v-btn
                      class="mt-1 mb-4"
                      block
                      :loading="loading"
                      @click="goToInternal"
                      color="#FFDD00"
                  >Login Internal
                  </v-btn>

                  <v-btn
                      style="border-color: #FFDD00;"
                      class="mt-8"
                      color="white"
                      block
                      @click="toVerifyFile()"
                  ><span class="black--text">Verifikasi File</span>
                  </v-btn>
                </div>

                <div v-else>
                  <v-btn
                      class="text-capitalize text-white mb-1" dark text
                      style="padding: 0"
                      @click="goBackToChoose"
                  >
                    &lt; Kembali
                  </v-btn>

                  <div class="mb-4">
                    <h3 style="font-weight: 800 !important;" class="text-white text-xl font-bold">Login Internal</h3>
                    <p class="text-white">Gunakan kredensial akun internal Anda.</p>
                  </div>

                  <v-form
                      ref="loginForm"
                      v-model="validLogin">
                    <v-text-field
                        id="mxUsername"
                        ref="username"
                        v-model="username"
                        background-color="white"
                        :class="{ mx_empty_filed: !username }"
                        :rules="[() => !!username || 'Username wajib diisi']"
                        placeholder="Username"
                        required
                        outlined
                        class="mb-2"
                    />
                    <v-text-field
                        id="mxPassword"
                        class="mb-2"
                        ref="password"
                        v-model="password"
                        background-color="white"
                        :class="{ mx_empty_filed: !password }"
                        :rules="[() => !!password || 'Password wajib diisi']"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Password"
                        counter
                        required
                        outlined
                        @keydown.enter="login"
                        @click:append="showPassword = !showPassword"
                    />
                  </v-form>

                  <div class="recaptcha">
                    <template>
                      <div>
                        <vue-recaptcha
                            ref="recaptcha"
                            @verify="onVerify"
                            @expired="onExpired"
                            :sitekey="sitekey"
                        >
                        </vue-recaptcha>
                      </div>
                    </template>
                  </div>

                  <div class="text-center">
                    <template>
                      <v-btn
                          class="mt-4"
                          block
                          :loading="loading"
                          @click="login()"
                          color="#FFDD00"
                      >Login
                      </v-btn>
                    </template>
                  </div>

                  <div class="text-center mt-2">
                    <template>
                      <v-btn class="text-capitalize text-white" dark text @click="forgotPassword()"
                      >Forgot Password?
                      </v-btn>
                    </template>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <div class="text-center mt-2">
            <template>
              <img style="margin-top:2rem;" src="../assets/bsre.png" alt="Logo" width="125px" height="auto">
            </template>
          </div>

          <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="10000" :top="true">
            {{ errorMessages }}
            <template v-slot:action="{ attrs }">
              <v-btn dark v-bind="attrs" text @click="snackbar = false">Close</v-btn>
            </template>
          </v-snackbar>

        </v-main>
      </v-col>

      <v-col class="desktop px-0 py-0 .d-none .d-lg-flex .d-xl-none align-items-center" cols="12" lg="7" md="7">
        <v-img src="../assets/bg-login-v4.png" style="width: 100%; height: 92vh; border-radius: 36px;"/>
      </v-col>

    </v-row>

    <v-dialog
        v-model="dialog" 
        max-width="500"
      >    
        <material-card
          color="primary"
          title="Forgot Password"
          class="card-wrapper elevation-0"
        >
               
          <v-form
            ref="form"
            v-model="valid"
          >
              <div style="height: 20px"></div>
              <v-text-field
                label="Username"
                v-model="form.username"
                outlined
                dense
                :rules="usernameRules"
              />
              <v-text-field
                label="Email"
                v-model="form.email"
                outlined
                dense
                :rules="emailRules"
                @keydown.enter="sendForgotPasswordRequest()"
              />
          
            <div class="row">
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeForgotPasswordDialog()">
                Kembali
              </v-btn>
              <v-btn
                  color="primary"
                  class="mr-4"
                  :loading="loadingForgotPassword" 
                  @click="sendForgotPasswordRequest()">
                Kirim
              </v-btn>
            </div>
        </v-form>
        </material-card>
    </v-dialog>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { apiServer } from "../setup-axios";
import { login_keycloak, logout_keycloak, updateToken } from "../services/KeycloakService";
import { backendUrl } from "../config/env";
export default {
  components: {
    VueRecaptcha,
  },
  data: function () {
    return {
      loginMode: 'choose', // choose | internal
      transitionName: 'slide-left',
      validLogin: false,
      username: "",
      password: "",
      sitekey: "6Ld7HC0pAAAAAPh4huLdPtrx2H-Li_pOcGNiV-Jq",
      errorMessages: "",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "primary",
      showPassword: false,
      loading: false,
      loadingSso: false,
      loadingForgotPassword: false,
      dialog: false,
      valid: false,
      usernameRules: [
        v => !!v || 'Username is required',,
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      form: {
        username: null,
        email: null,
      },
    };
  },

  methods: {
    goToInternal() {
      this.transitionName = 'slide-left'
      this.loginMode = 'internal'
    },
    goBackToChoose() {
      this.transitionName = 'slide-right'
      this.loginMode = 'choose'
      this.resetInternalForm()
    },
    resetInternalForm() {
      this.username = ''
      this.password = ''
      this.showPassword = false
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset()
      }
    },
    onVerify: function (response) {
      this.recaptcha = response;
      console.log("Verify: " + this.recaptcha);
    },
    onExpired: function () {
      console.log("Expired");
      this.recaptcha = '';
      console.log("Captcha Expired: " + this.recaptcha);
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    forgotPassword() {
      this.dialog = true
    },
    sendForgotPasswordRequest() {
      this.loadingForgotPassword = true
      if (this.valid) {
        console.log("sendForgotPasswordRequest() is called")
        apiServer
            .post("/forgot-password", this.form)
            .then(response => {
              console.log(response.data.message)
              this.showSnackbar("orange", "Permintaan Reset Password berhasil dilakukan. Jika akun dengan email tersebut ditemukan, maka email Reset Password akan dikirim ke email tersebut.");
              this.closeForgotPasswordDialog()
            })
            .catch(error => {
              console.log("There was an error:", error);
              console.log(error.response.data.message)
              if (error.response.data.message.includes("SSO")) {
                this.showSnackbar(
                    "error",
                    error.response.data.message
                );
              } else {
                this.showSnackbar(
                    "error",
                    "Terjadi kesalahan pada sistem, silakan hubungi Administrator"
                );
              }
            });
            this.loadingForgotPassword = false
      } else {
        this.loadingForgotPassword = false
        console.log(this.form.username + " - " + this.form.email)
        if (this.form.username == "" || this.form.email == ""|| this.form.username == null || this.form.email == null) {
          this.showSnackbar(
                "error",
                "Username dan email wajib diisi."
            );
        } else {
          this.showSnackbar(
                "error",
                "Username/email Anda salah"
            );
        }
      }
    },
    closeForgotPasswordDialog() {
      this.dialog = false
      this.loadingForgotPassword = false
      this.$refs.form.resetValidation()
    },
    showSnackbar(color, message) {
      console.log("snackbar " + color + " - " + message)
      this.snackbar = true
      this.errorMessages = message
      this.snackbarColor = color
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    async loginSSO() {
      await login_keycloak()
    },
    logoutSSO() {
      logout_keycloak()
    },
    refreshSSO() {
      updateToken()
    },
    toVerifyFile() {
      this.$router.push("/verify-file")
    },
    login: function () {
      console.log("masuk login")
      if (
        this.username &&
        this.password
        && this.recaptcha
      ) {
        let username = this.username;
        let password = this.password;
        this.loading = true;
        console.log("debug : " + username);
        console.log("baseurl : " + apiServer.defaults.baseURL);
        console.log("backendUrl : " + backendUrl);
        this.$store
          .dispatch("login", { username, password })
          .then(() => this.$router.push("/profil"))
          .catch((err) => {
            this.loading = false;
            console.log("data:",this.$store.state.errorLogin.pesan);
            if (this.$store.state.errorLogin.pesan === 'User tidak aktif') {
              this.errorMessages = 'Username Anda tidak aktif. Harap hubungi Administrator'
              this.resetRecaptcha();
              // this.showSnackbar("error", 'Username Anda tidak aktif. Harap hubungi Administrator.');
            } else if (this.$store.state.errorLogin.pesan === "Username atau Password tidak sesuai" || this.$store.state.errorLogin.pesan == 'crypto/bcrypt: hashedPassword is not the hash of the given password' || this.$store.state.errorLogin.pesan == 'sql: no rows in result set') {
              this.errorMessages = 'Username atau Password tidak sesuai'
              this.resetRecaptcha();
              // this.showSnackbar("error", 'Username/Password Anda salah.');
            } else if (this.$store.state.errorLogin.pesan === 'IP tidak terdaftar') {
              this.errorMessages = 'Alamat IP anda diluar daftar IP yang diizinkan'
              this.resetRecaptcha();
              // this.showSnackbar("error", 'Alamat IP anda diluar daftar IP yang diizinkan');
            } else if (this.$store.state.errorLogin.pesan === 'User tidak aktif. Silakan hubungi Administrator') {
              this.errorMessages = 'Akun pengguna ini tidak aktif. Silakan hubungi Administrator'
              this.resetRecaptcha();
            } else if (this.$store.state.errorLogin.pesan.includes('Silakan login lagi') || this.$store.state.errorLogin.pesan.includes('Pengguna belum memiliki peran apapun')) {
              this.errorMessages = this.$store.state.errorLogin.pesan
              this.resetRecaptcha();
            } else if (this.$store.state.errorLogin.pesan === 'Akun Pengguna tidak aktif. Silakan hubungi Administrator') {
              this.errorMessages = 'Akun Pengguna tidak aktif. Silakan hubungi Administrator'
              this.resetRecaptcha();
              // this.showSnackbar("error", 'Alamat IP anda diluar daftar IP yang diizinkan');
            } else {
              this.errorMessages = 'Terdapat kesalahan pada Sistem. Silakan hubungi Administrator.'
              this.resetRecaptcha();
            }
            this.snackbarColor = "error"
            this.snackbar = true;
          });
      } else {
        this.resetRecaptcha();
        console.log("field belum terisi semua");
        this.errorMessages = 'Username, password, dan captcha wajib diisi.'
        this.snackbarColor = "error"
        this.snackbar = true;
      }
    },
  },
  metaInfo() {
    return {
      title: "eSign | Login",
    };
  },
  created() {
    console.log("isi snackbarText state: ", this.$store.state.snackbar.snackbarText)
    this.snackbarText = localStorage.getItem('snackbarText')
    console.log("isi snackbarText localstorage: ", this.snackbarText)
    // console.log("isi snackbar.errorMessages: ", this.$store.state.snackbar.snackbarText)
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    } else if (this.snackbarText === "Logout Berhasil") {
      this.showSnackbar("primary",this.snackbarText)
      this.snackbarText = ""
      localStorage.removeItem('snackbarText')
    }
    setTimeout(() => {
      console.log("isi snackbarText localstorage timeout 1: ", this.snackbarText)
      if (this.snackbarText) {
        this.showSnackbar("orange", this.snackbarText)
        this.snackbarText = ""
        localStorage.removeItem('snackbarText')
      }
    }, 2000)

    setTimeout(() => {
      let keycloakLoggedIn = localStorage.getItem('keycloakLoggedIn')
      console.log("isi keycloakLoggedIn localstorage timeout 2: ", keycloakLoggedIn)
      if (keycloakLoggedIn) {
        this.$router.push('/profil').catch((error) => {
          console.log("Router push failed: ", error);
          apiServer.get('/test', { timeout: 5000 }).then(response => {
            console.log("isi response: ", response)
          }).catch(error => {
            console.log("API Server Destination: ", apiServer.defaults.baseURL);
            this.showSnackbar("red", "Terdapat kesalahan pada Sistem. Silakan hubungi Administrator.")
          })
        });
      }
      localStorage.removeItem('snackbarText')
    }, 4000)
  },
  
};
</script>
<style>
@import url("../css/login.css");
.login-transition-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 450px;
}

.login-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.center-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 450px;
}

/* TRANSITION KE KIRI */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease;
}

.slide-left-enter {
  transform: translateX(100%);
}
.slide-left-leave-to {
  transform: translateX(-100%);
}

/* TRANSITION KE KANAN */
.slide-right-enter {
  transform: translateX(-100%);
}
.slide-right-leave-to {
  transform: translateX(100%);
}

.divider {
  position: relative;
  text-align: center;
  margin: 16px 0;
}

.divider::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.35);
  transform: translateY(-50%);
}

.divider-text {
  position: relative;
  padding: 0 8px;
  background-color: #0D3A8C;
  color: white;
  font-size: 12px;
  text-transform: uppercase;
}

.v-text-field__details {
  display: none;
}
</style>
